import { execute } from 'fg-frontend/src/partialUpdate/partialUpdate';

export default (params) => {
  execute(params);
  window.edeeshopPopup.close();

  document.addEventListener('partialUpdateComplete', ({ detail: { settings, hasError, newAccessibleTarget } }) => {
    if (settings.target == params.target && !hasError) {
      window.location = document.getElementById('shoppingListListing_name_detailLink-0').getAttribute('href');
    }
  });
};



// WEBPACK FOOTER //
// ./fe/web-prefa/src/js/webActions/skipToNewItem.js